import _ from "underscore";
import Auth from '@/helpers/middleware';
import SysMsg from "@/helpers/system.message";
import UsersServices from "@/services/users.services";

import userAccess from '@/components/usuarios/accesos'

export default {
  name: "users",
  components: {
    userAccess
  },
  data() {
    return {
      controller: {
        title: "Usuarios",
        mainRouter: "/tinforamcion/usuarios"
      },
      paginate: ['Listadotmp'],
      addMode: false,
      editMode: false,
      tmp: [],
      searchInput: "",
      editMode: false,
      users: [],
      listasystem: [],
      ListaStatus: [],
      idValStatus: "",
      emailexiste: 0,
      passwordgenerada: "",
      filtroSistema: 0,
      verdadero: true,
      newUser: {
        nombre: "",
        email: "",
        clave: "",
        id_sistema: 0,
        status: {
          id: null,
          value: ""
        }
      },
      password: {
        current: "",
        new: "",
        confirm: ""
      },
      user: {
        id: null,
        name: "",
        email: "",
        fecha_creacion: "",
        fecha_actualizacion: "",
        usuario: "",
        id_sistema: 0,
        status: {
          id: null,
          value: ""
        }
      },
      useractual: Auth.getUser(),
      regEmail: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      userAcess: null
    };
  },
  watch: {
    password: {
      deep: true,
      handler(data) {
        this.hideEdit = data.new.trim().length + data.confirm.trim().length > 0;
        this.updatePassword =
          this.hideEdit && data.new.trim() == data.confirm.trim();
        this.user.clave =
          this.hideEdit && this.updatePassword && data.current.trim().length > 0
            ? data.current
            : null;
        this.user.clave_nueva =
          this.hideEdit && this.updatePassword && data.current.trim().length > 0
            ? data.new
            : null;
      }
    }
  },
  computed: {
    updatePasswordClass: {
      get() {
        let passwordNew = this.password.new ? this.password.new.trim() : "";
        let passwordConfirm = this.password.confirm
          ? this.password.confirm.trim()
          : "";

        return passwordNew.trim().length + passwordConfirm.trim().length == 0
          ? ""
          : passwordNew.trim().length + passwordConfirm.trim().length > 0 &&
            passwordNew.trim() != passwordConfirm.trim()
            ? "has-danger"
            : "has-success";
      }
    },
    Listadotmp(status) {
      let search = this.searchInput;

      let cloneTMP = _.clone(_.filter(this.tmp, function (filter) {
        return (filter.name.toString().trim().toLowerCase().indexOf(search.toString().trim().toLowerCase()) > -1) || filter.email.toString().trim().toLowerCase().indexOf(search.toString().trim().toLowerCase()) > -1;
      }));

      this.paginate.Listadotmp.list = cloneTMP.length == 0 ? this.tmp : cloneTMP;
      this.paginate.Listadotmp.page = 0;

      return cloneTMP;
    },

    getsistema() {

      return _.find(this.$route.meta.filter, (filter) => { return filter.path == this.$route.path }) ? _.find(this.$route.meta.filter, (filter) => { return filter.path == this.$route.path }).sistema : 0;
    }

  },
  created() {
    this.getAll();
    this.getsystem();
    this.getstatus();
  },
  mounted(){
    //Impide que se cierre el dropdown al hacer click.
    $('body').on("click", ".dropdown-menu.special", function (e) {
      e.stopPropagation();
  });
  },
  methods: {
    getAll() {
      this.loading = true;
      UsersServices.admin
        .getAll('', 0, this.getsistema)
        .then(response => {
          this.tmp = _.sortBy(response.data.user, (sort)=>{ return sort.name; });
          this.users =_.sortBy(response.data.user, (sort)=>{ return sort.name; });
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          SysMsg.getResponseMessage(error.response);
        });
    },
    getsystem() {
      UsersServices.admin.GetSystem(this.getsistema).then(response => {

        this.listasystem = response.data.lista;

      }).catch(error => {
        SysMsg.getResponseMessage(error.response);
      });

    },
    getstatus() {
      UsersServices.admin.GetUserStatus(0).then(response => {

        this.ListaStatus = response.data.lista.map(i => ({
          caption: i.caption,
          icono: i.icono,
          id: i.id,
          active: null
        }));

        this.ListaStatus[0].active = true;

      }).catch(error => {
        SysMsg.getResponseMessage(error.response);
      });

    },
    updateUser() {

      if (this.user.id_sistema == 0) {
        SysMsg.getMessage("Debe seleccionar un sistema.", "warning");
      } else {
        this.user.usuario = this.useractual.email;
        this.user.nombre = this.user.name;
        this.user.statusId = this.user.status.id;

        UsersServices.login.update(this.user).then(response => {
          this.updateModelUserList(response.data);
          this.resetData();
          if(this.user.id_sistema == 1){
            this.setUserAccess();            
          }else{
            this.$refs.mdlCloseUsr.click();
            SysMsg.getMessage("Usuario actualizado con éxito", "success");
          }
        }).catch(error => {
          console.log(error);
          this.loading = false;
          SysMsg.getResponseMessage(error.response);
        });

      }

    },
    showInfo(user) {
      this.getUserAccess(user);
      this.editMode = true;
      this.user = user;
      //this.$refs.myModalRef.show();
    },
    CambioStatus() {

      this.user.nombre = this.user.name;
      this.user.usuario = this.useractual.email;
      this.user.statusId = this.user.status.id;
      if (this.user.status.id == 1) {
        this.user.statusId = 2;
      } else if ((this.user.status.id == 2)) {
        this.user.statusId = 1;
      } else if ((this.user.status.id == 3)) {
        this.user.statusId = 1;
      }
      UsersServices.login.update(this.user).then(response => {
        SysMsg.getMessage("Usuario actualizado con éxito", "success");
        this.updateModelUserList(response.data);
      }).catch(error => {

        SysMsg.getResponseMessage(error.response);

      });

    },
    CambioEliminar: function (pess) {

      this.user.nombre = this.user.name;
      this.user.usuario = this.useractual.email;
      this.user.statusId = this.user.status.id;

      if (this.user.status.id == 3) {
        this.user.statusId = 1;
      } else {
        this.user.statusId = 3;
      }

      UsersServices.login.update(this.user).then(response => {
        SysMsg.getMessage("Usuario actualizado con éxito", "success");
        this.updateModelUserList(response.data);
      }).catch(error => {

        SysMsg.getResponseMessage(error.response);

      });

    },
    filterStatus(data, status) {
      this.tmp = _.filter(data, function (filter) {
        return filter.status.id == status;
      });
    },
    updateInfo() {
      this.user.nombre = this.user.name;
      this.user.usuario = this.useractual.email;
      this.user.statusId = this.user.status.id;
      this.user.clave = this.password.current;
      this.user.clave_nueva = this.password.new;
      UsersServices.login
        .update(this.user)
        .then(response => {
          this.loading = false;
          if (response.data.result.status == 1) {
            SysMsg.getMessage("Usuario Actualizado correctamente", "info");
            this.updateModelUserList(response.data);
            this.resetData();

          } else if (this.password.current.trim().length > 0) {
            SysMsg.getMessage("La contraseña actual no es valida", "warning");
          } else {
            SysMsg.getMessage(
              "Ocurrio un error, favor intentar más tarde",
              "error"
            );
          }
        })
        .catch(error => {
          SysMsg.getResponseMessage(error.response);
        });
    },
    GetUserEmail() {

      if (this.ValidaFormatoEmailNewUser() == 0) {
        UsersServices.admin
          .GetUserEmail(this.newUser.email)
          .then(response => {

            SysMsg.getMessage("Email ya registrado.", "warning");
            this.newUser.email = "";
            this.newUser.clave = "";
            this.emailexiste = 1;
          })
          .catch(error => {
            SysMsg.getMessage("Email puede ser usado.", "success");
            this.emailexiste = 0;
            this.newUser.clave = this.newUser.email.substring(0, this.newUser.email.lastIndexOf("@")) + new Date().getFullYear();
          });

      }
    },
    addNewUser() {
      this.loading = true;
      this.newUser.statusId = 1;
      this.newUser.usuario = this.useractual.email;

      if (this.newUser.id_sistema == 0) {

        SysMsg.getMessage("Debe seleccionar un sistema.", "warning");

      } else {

        if (this.ValidaFormatoEmailNewUser() == 0) {
          UsersServices.login.update(this.newUser).then(response => {
            SysMsg.getMessage("Usuario creado con éxito", "success");
            this.addMode = false;
            this.updateModelUserList(response.data, true);
            this.resetData();
            this.loading = false;
          }).catch(error => {
            SysMsg.getResponseMessage(error.response);
            this.addMode = true;
          });
        }
      }

    },
    SearchStatus(st) {

      var stid = st.id;

      var strid = st.caption ? st.caption : "todos";

      this.tmp = _.filter(this.users, filter => { return stid > 0 ? (filter.status.id.toString() == stid.toString()) : filter.status.id; });

    },
    resetData() {
      var self = this;

      Object.keys(this.password).forEach(function (key, index) {
        self.password[key] = '';
      });

      /* Object.keys(this.user).forEach(function (key, index) {
        self.user[key] = '';
      }); */

      Object.keys(this.newUser).forEach(function (key, index) {
        self.newUser[key] = '';
      });


    },
    ValidaFormatoEmailNewUser() {

      if (this.newUser.email != "") {

        if (this.regEmail.test(this.newUser.email)) {

          return 0;

        } else {
          this.newUser.clave = "";
          SysMsg.getMessage("Email debe estar bien formado.", "warning");
          return 1;
        }

      } else {
        this.newUser.clave = "";
        SysMsg.getMessage("Email es necesario.", "warning");
        return 1;
      }

    },
    showModal() {
      //this.$refs.myModalRef.show()
    },
    hideModal() {
      //this.$refs.myModalRef.hide()
      this.getAll();
    },
    getUserAccess(user) {
      if (user.id_sistema == 1) {
        UsersServices.admin.getUserAccess(user.id).then(response => {
          this.userAcess = response.data;
        }).catch(error => {
          SysMsg.getResponseMessage(error.response);
        });
      }
    },
    setUserAccess() {
      if (this.userAcess) {

        /*valida menu-> submenu activo*/
        let validate = 0;
        
        _.each(_.filter(this.userAcess.departments, (filter)=>{ return filter.active; }), (data, index)=>{
          _.each(_.filter(data.menu, (filter)=>{ return filter.active && filter.submenu.length > 0; }), (menu)=>{
            if(_.filter(menu.submenu, (submenu)=>{ return submenu.active; }).length == 0){
              SysMsg.getMessage("Debe seleccionar al menos un submenu en el Menú -> " + menu.caption, "warning");
              validate++;
            }
          })
        });

        if(validate > 0){
          this.loading = false;
          return false;
        }
        /*fin valida menu-> submenu */

        UsersServices.admin.setUserAccess(this.userAcess).then(response => {
          this.$refs.mdlCloseUsr.click();
          SysMsg.getMessage("Usuario actualizado con éxito", "success");
        }).catch(error => {
          SysMsg.getResponseMessage(error.response);
        });
      }
    },
    updateModelUserList(data, nuevo) {
      if (nuevo) {
        this.users.push(data);
        this.tmp.push(data);
      } else {
        _.extend(_.findWhere(this.users, { id: data.id }), data);
      }
    }
  }
};